module.exports = __webpack_public_path__ + "img/logo.c86cfd22.png";